export default [
    {
        "id": "0",
        "path": "textures/big/__0.jpg",
        "iconPath": "textures/small/__0.jpg",
        "description": "Simple 2",
        "meshParameter": "15"
    },
    {
        "id": "1",
        "path": "textures/big/__1.jpg",
        "iconPath": "textures/small/__1.jpg",
        "description": "Nevada ash",
        "meshParameter": "12"
    },
    {
        "id": "2",
        "path": "textures/big/__2.jpg",
        "iconPath": "textures/small/__2.jpg",
        "description": "Simple 3",
        "meshParameter": "8"
    },
    {
        "id": "3",
        "path": "textures/big/__3.jpg",
        "iconPath": "textures/small/__3.jpg",
        "description": "Simple 51",
        "meshParameter": "20"
    },
    {
        "id": "4",
        "path": "textures/big/__4.jpg",
        "iconPath": "textures/small/__4.jpg",
        "description": "Bahama Green 17",
        "meshParameter": "50"
    },
    {
        "id": "5",
        "path": "textures/big/___5.jpg",
        "iconPath": "textures/small/___5.jpg",
        "description": "Nevada Mocca",
        "meshParameter": "12"
    },
    {
        "id": "6",
        "path": "textures/big/__6.jpg",
        "iconPath": "textures/small/__6.jpg",
        "description": "Simple 33",
        "meshParameter": "20"
    },
    {
        "id": "7",
        "path": "textures/big/___7.jpg",
        "iconPath": "textures/small/___7.jpg",
        "description": "Dream denim",
        "meshParameter": "10"
    },
    {
        "id": "8",
        "path": "textures/big/__8.jpg",
        "iconPath": "textures/small/__8.jpg",
        "description": "Savanna nova purple",
        "meshParameter": "30"
    },
    {
        "id": "9",
        "path": "textures/big/__9.jpg",
        "iconPath": "textures/small/__9.jpg",
        "description": "Dream berry",
        "meshParameter": "10"
    },
]
